/* media-filter.js - Media Filter Module
 ================================================== */
import MediaFilterComponent from '~/bundles/media/components/filter/media_filter';

window.MediaFilter = function(opts) {

    var defaults = {
        filterType: 'media',
        filterLayout: 'topTagsFolders',

        mediaList: '#js-media-list',
        mediaTypeItem: '.js-media-type-item',
        mediaStatusItem: '.js-media-status-item',
        baseTemplateTypeItem: '.js-base-template-type-item',
        folderSelect: '.js-folder-select',
        tagSelect: '.js-tag-select',
        sortSelect: '#js-sort-select',
        sortSelectManageMedia: '#js-sort-select.manage-media',
        searchField: '#js-search-field',
        searchButton: '#js-search-btn',
        tileButton: '.tile-tab-btn',
        listButton: '.list-tab-btn',
        listTab: '#list-tab',
        tileTab: '#tile-tab',
        listScript: '#list-results',
        tileScript: '#tile-results',
        searchUrl: '/media/search-layouts',
        foldersUrl: '/media/folders/list',
        filterUrl: '',
        tagsUrl: '/media/tags/list',
        tagFormUrl: '/media/tags/user-form',
        cloneUrl: '/media/clone',
        cloneRedirectUrl: '/manage-media/form',
        editTagsField: '#js-edit-tags-field',
        editTagsModal: '#js-edit-tags-modal',
        editTagsLink: '.js-edit-tags-link',
        editTagsForm: '#js-edit-tags-form',
        submitTagsButton: '#js-submit-tags-btn',
        videoModal: '#js-media-video-link-modal',
        videoModalButton: '.js-media-video-modal-trigger',
        deleteEmailButton: '.js-email-delete-btn',
        deleteSavedSocialButton: '#social-cover-action-btn.delete-btn',
        viewTypeKey: 'mediaView',
        defaultViewType: '.tile-tab-btn',
        additionalParams: {},
        loadResultsCallback: null
    };

    var tags = [];
    var folders = [];

    var tagsUrl;

    var options = $.extend(defaults, opts);

    var queryParams = Object.assign({
        page: 1,
        page_size: 18,
        search: "",
        sort: "newest",
        type: 0,
        status: "",
        template_type: "",
        exclude_base: false,
        tags: [],
        folders: []
    }, options.additionalParams);

    var $folderSelect = $(options.folderSelect);
    var $tagSelect = $(options.tagSelect);
    var $sortSelect = $(options.sortSelect);
    var $sortSelectManageMedia = $(options.sortSelectManageMedia);
    var $searchField = $(options.searchField);
    var $searchButton = $(options.searchButton);
    var $mediaTypeItem = $(options.mediaTypeItem);
    var $mediaStatusItem = $(options.mediaStatusItem);
    var $baseTemplateTypeItem = $(options.baseTemplateTypeItem);
    var $editTagsModal = $(options.editTagsModal);
    var $editTagsField = $(options.editTagsField);
    var $editTagsForm = $(options.editTagsForm);
    var $submitTagsButton = $(options.submitTagsButton);
    var $tileButton = $(options.tileButton);
    var $listButton = $(options.listButton);
    var $listTab = $(options.listTab);
    var $tileTab = $(options.tileTab);
    var $listScript = $(options.listScript);
    var $tileScript = $(options.tileScript);
    var $selectPicker = $('.selectpicker');
    var $deleteEmailButton = $(options.deleteEmailButton);
    var $deleteSavedSocialButton = $(options.deleteSavedSocialButton);
    var $videoModal = $(options.videoModal);
    var $videoModalButton = $(options.videoModalButton);
    var $useAdvancedSearch = options.additionalParams.use_advanced_search == 1 ? true : false;

    // this is for the new tags and folders sidebar filter,
    // this will be refactored when the whole page is transfered to vue
    var VueMediaFilter;

    function setLocationParams() {
        var search = '?' + $.param(queryParams);
        history.pushState(null, '', window.location.pathname + search);
    }

    function applyFiltersAndLoad() {
        setLocationParams();
        loadTags();
        loadResults(function() {
            fillOutForm();
        });
    }

    function setMobileFilter() {
        if ($(window).width() <= 768) {
            $('.js-desktop-filter').remove();
        } else {
            $('.js-mobile-filter').remove();
        }
    }

    function setQueryParams() {
        var search = window.location.search;
        var hash = window.location.hash;
        if (search) {
            queryParams = $.deparam(search.replace(/^\?/, ""));
        } else if (hash) {
            // backward compatibility: migrate existing hash-based URLs to query params
            queryParams = $.deparam(hash.replace(/\/?#/, ""));
            // use replaceState here so the pre-migration hash URL doesn't linger in history
            history.replaceState(null, '', window.location.pathname + '?' + $.param(queryParams));
        }
    }

    function setFolder(folderElement){
        var folderVal = $(folderElement).val();
        if(folderVal == null){
            queryParams.folders = [];
        } else {
            queryParams.folders = folderVal;
        }
    }

    function resetVueFolders() {
        if (VueMediaFilter) {
            VueMediaFilter.$store.commit('media/set', {
                activeFolders: []
            })
        }
    }

    function setTags(tagElement){
        var tagVal = $(tagElement).val();
        queryParams.tags = tagVal && tagVal.length ? tagVal : [];
    }

    function setVueTags() {
        if (VueMediaFilter) {
            gl.MediaFilterApp.$on('tagChange', checkedTags => {
                queryParams.tags = (tagVal == null) ? [] : tagVal;
            });
        }
    }

    function resetVueTags() {
        if (VueMediaFilter) {
            VueMediaFilter.$store.commit('media/set', {
                activeTags: []
            })
        }
    }

    function setType(typeElement){
        $('#content').find(options.mediaTypeItem).each(function(){
            $(this).removeClass('active');
        });
        $(typeElement).addClass('active');
        queryParams.type = $(typeElement).attr('data-type-id');
    }

    function setStatus(statusElement) {
        $mediaStatusItem.each(function(){
            $(this).removeClass('active');
        });
        $(statusElement).addClass('active');
        queryParams.status = $(statusElement).attr('data-status');
    }



    function baseTemplateTypeClickHandler(baseType) {
        var selected = null;

        $baseTemplateTypeItem.each(function(){
            if ($(this).hasClass('active')) {
                selected = this;
            }
            $(this).removeClass('active');
        });

        if($(selected).attr('data-template-type') == $(baseType).attr('data-template-type')) {
            queryParams.template_type = "";
            return;
        }

        setBaseTemplateType(baseType);
    }

    function setBaseTemplateType(baseType) {
        $(baseType).addClass('active');
        queryParams.template_type = $(baseType).attr('data-template-type');
    }

    function manageBestMatchOption() {
        if($useAdvancedSearch){
            $sortSelect.children('option[value="rank"]').remove();
            $sortSelectManageMedia.children('option[value="rank"]').remove();
            if(queryParams.search && queryParams.search.trim() !== '') {
                if($sortSelectManageMedia.length) {
                    $sortSelectManageMedia.append('<option value="rank">Best Match</option>');
                    if(queryParams.sort === "rank") {
                        $sortSelectManageMedia.val("rank");
                    }
                } else {
                    $sortSelect.append('<option value="rank">Best Match</option>');
                }
            }
        }
    }

    function setSearch(self){
        queryParams.search = $searchField.val();
        if($useAdvancedSearch && queryParams.search.trim() !== '') {
            manageBestMatchOption();
            queryParams.sort = "rank";
        } else {
            queryParams.sort = "newest";
        }
    }

    function setSort(sortElement){
        queryParams.sort = $(sortElement).val();
    }

    function resetPage() {
        queryParams.page = 1;
    }

    function nextPage() {
        queryParams.page = parseInt(queryParams.page) + 1;
        scrollToTop();
    }

    function prevPage() {
        queryParams.page = parseInt(queryParams.page) - 1;
        scrollToTop();
    }

    function scrollToTop() {
        $('html, body').animate({scrollTop : 0}, 300);
    }

    function fillOutForm() {
        $searchField.val(queryParams.search);
        $folderSelect.val(queryParams.folders);
        $tagSelect.val(queryParams.tags);
        if($useAdvancedSearch) {
            manageBestMatchOption();
        }
        $sortSelect.val(queryParams.sort);
        $selectPicker.selectpicker('refresh');
        setType($('[data-type-id="' + queryParams.type + '"]'));
        setStatus($('[data-status="' + queryParams.status + '"]'));
        setBaseTemplateType($('[data-template-type="' + queryParams.template_type + '"]'));
    }

    function renderTemplate(data) {
        if ($listScript.length && $tileScript.length) {
            var listTemplate = Handlebars.compile($listScript.html());
            var tileTemplate = Handlebars.compile($tileScript.html());

            $listTab.empty();
            $tileTab.empty();
            $listTab.append(listTemplate(data));
            $tileTab.append(tileTemplate(data));
        }

        pagination(data);
        templateActions();
    }

    function selectView() {
        var viewTypeButton = options.defaultViewType;

        $.ajax({
            url: '/organization/settings/user-interface/settings',
            type: 'GET',
            success: function(data, txt, xhr){
                let orgDefaultView = data.settings.media_default_view;

                if (orgDefaultView) {
                    viewTypeButton = orgDefaultView;
                }

                if (localStorage.getItem(options.viewTypeKey)){
                    viewTypeButton = localStorage.getItem(options.viewTypeKey);
                }
                $(viewTypeButton).click();
            }
        });
    }

    function pagination(data) {
        var currentPage = parseInt(data.meta.current_page);
        var totalPages = parseInt(data.meta.total_pages);

        if (currentPage == 1) {
            $('.js-prev-page').addClass('hidden');
        } else {
            $('.js-prev-page').removeClass('hidden');
        }

        if (currentPage + 1 > totalPages) {
            $('.js-next-page').addClass('hidden');
        } else {
            $('.js-next-page').removeClass('hidden');
        }

        if (totalPages < 1) {
            $('.pagination-count').addClass('hidden');
        } else {
            $('.pagination-count').removeClass('hidden');
        }
    }

    function loadResults(callback) {
        if(options.searchUrl){
            var emptyResults;
            spinnerModule.startElementSpinner('.tab-content-media-library');
            $listTab.empty();
            $tileTab.empty();
            $.ajax({
                url: options.searchUrl,
                type: 'GET',
                dataType : "json",
                data: queryParams,
                success: function(json, txt, xhr){
                    spinnerModule.stopElementSpinner('.tab-content-media-library');
                    if (xhr.status == 200 && json.meta.total_pages > 0 ) {
                        renderTemplate(json);
                        selectView();
                    } else {
                        emptyResults = buildEmptyPanel('No Media Found', 'Try changing your search terms or tags', 'fa-file-image-o');
                        $listTab.html(emptyResults);
                        $tileTab.html(emptyResults);
                        selectView();
                    }

                    if (typeof callback === 'function') {
                        callback(json);
                    }
                }
            });
        }
    }

    function loadFolders() {
        $.ajax({
            url: options.foldersUrl,
            type: 'GET',
            data: queryParams,
            global: false,
            success: function(data, txt, xhr) {
                if (xhr.status == 200) {

                    buildSelectpickerFolders(data);
                    if (options.filterLayout) {
                        setVueMediaFolders(data.folders)
                    }

                }
            }
        });
    }

    function setVueMediaFolders(folders) {
        if (VueMediaFilter) {
            VueMediaFilter.$store.commit('media/set', {
                folders: folders
            });
        }
    }

    function buildSelectpickerFolders(data) {
        var i = 0;
        var currentFolder;
        var folderCount = '';
        $folderSelect.find('option').remove();

        if (data.folders && data.folders.length) {
            for (i = 0; i < data.folders.length; i++) {
                currentFolder = data.folders[i];
                if(currentFolder.folder_count !== undefined) {
                    folderCount = "<span class='badge pull-right'>" + currentFolder.folder_count + "</span>";
                }
                $folderSelect.append("<option value='" + currentFolder.id + "'>" + currentFolder.name + folderCount +"</option>");
            }
        }

        $folderSelect.val(queryParams.folders);

        $selectPicker.selectpicker('refresh');
    }

    function loadTags() {
        $.ajax({
            url: options.tagsUrl,
            type: 'GET',
            data: queryParams,
            global: false,
            success: function(data, txt, xhr) {
                if (xhr.status == 200) {
                    buildSelectpickerTags(data);
                    if (options.filterLayout) {
                        setVueMediaTags(data.tags);
                    }

                }
            }
        });
    }

    function setVueMediaTags(tags) {
        if (VueMediaFilter) {
            VueMediaFilter.$store.commit('media/set', {
                tags: tags
            });
        }
    }

    function buildSelectpickerTags(data) {
        var i = 0;
        var currentTag;
        var tagCount = '';
        $tagSelect.find('option').remove();
        var optionParent = $('.dropdown-menu.inner.selectpicker');
        optionParent.css('width', 'max-content');
        for (i = 0; i < data.tags.length; i++) {
            currentTag = data.tags[i];
            if(currentTag.tag_count !== undefined) {
                tagCount = "<span class='badge pull-right'>" + currentTag.tag_count + "</span>";
            }
            $tagSelect.append("<option value='" + currentTag.id + "'>" + currentTag.name + tagCount + "</option>");
        }

        $tagSelect.val(queryParams.tags);

        $selectPicker.selectpicker('refresh');
    }

    function loadEditTagsForm(editTagLink) {
        var mediaId = $(editTagLink).attr('data-media-id');
        tagsUrl = options.tagFormUrl + '/' + mediaId;
        $.ajax({
            url: tagsUrl,
            type: 'GET',
            global: false,
            success: function(data, txt, xhr) {
                var i = 0;
                if (xhr.status == 200) {
                    initTagIt(data.tags);
                    $editTagsField.tagit("removeAll");
                    for (i = 0; i < data.assigned_tags.length; i++) {
                        $editTagsField.tagit("createTag", data.assigned_tags[i]);
                    }
                    $editTagsModal.modal('show');
                }
            }
        });
    }

    function deleteEmail(deleteButton) {
        var emailId = $(deleteButton).attr('data-email-id');

        $.ajax({
            url: '/email/delete',
            data: {
                id: emailId
            },
            type: 'POST',
            global: false,
            success: function(data) {
                removeRow(emailId);
            }
        }).fail(function(){
            buildFlashMessage('Email template could not be deleted', 'danger');
        });
    }

    function deleteSavedSocial(deleteButton) {
        $.ajax({
            url: $(deleteButton).attr('href'),
            type: 'POST',
            data: $(deleteButton).data(),
            success: function (data) {
                buildFlashMessage('Successfully Removed', 'success');
                    loadResults(function() {
                        fillOutForm();
                    });
                updateVueMediaFilters();
            },
            error: function(data) {
                buildFlashMessage("Operation Failed", 'danger');
            }
        });
    }

    function submitTags() {
        $.ajax({
            url: tagsUrl,
            type: 'POST',
            data: $editTagsForm.serialize(),
            global: false,
            success: function(data, txt, xhr) {
                if (xhr.status == 200) {
                    window.location.reload();
                }
            }
        });
    }

    function archiveMedia(button) {
        $.ajax({
            url: button.attr('href'),
            type: 'POST',
            data: button.data(),
            success: function(data) {
                removeRow(data.id);
            }
        });
    }

    function removeRow(rowId) {
        $('.item-row[data-row-id="' + rowId + '"]').remove();
    }

    function initTagIt(availableTags){
        $editTagsField.tagit({
            availableTags: availableTags,
            showAutocompleteOnFocus: true,
            allowSpaces: true,
            placeholderText: "Create or select a tag",
            autocomplete: {
                appendTo: "#js-edit-tags-modal",
                delay: 100
            }
        });
    }

    // These are called after the handlebars template is rendered
    function templateActions() {
        $('.js-next-page').on('click', function(e) {
            nextPage();
            applyFiltersAndLoad();
        });

        $('.js-prev-page').on('click', function() {
            prevPage();
            applyFiltersAndLoad();
        });

        $('a[data-featherlight="image"]').featherlight();
    }

    function fillInVideoModal(self) {
        var video = $(self).attr('data-video');
        var videoTitle = $(self).attr('data-video-title');

        $('.js-media-video-title').html(videoTitle);
        $('.js-media-video-iframe-container').html(video);
    }

    function createVueMediaFilters() {
        const $el = $('#vue-media-filter');

        if ($el.length) {
            options.filterLayout = $el.data('layout-type');
            VueMediaFilter = new MediaFilterComponent({
                el: $el.get(0),
                propsData() {
                    return {
                        showTypes: $el.data('show-types')
                    }
                }
            });

            VueMediaFilter.$store.commit('media/set', {
                activeFolders: queryParams.folders || [],
                activeTags: queryParams.tags || [],
                types: $el.data('types'),
                totalTypeCount: $el.data('total-type-count'),
                layoutType: options.filterLayout
            });

            if(options.filterUrl) {
                updateVueMediaFilters(queryParams);
            }
        }
    }

    function updateVueMediaFilters(parameters) {
        let url = options.filterUrl || options.searchUrl;
        $.ajax({
            url: url,
            method: 'GET',
            data: parameters,
        })
        .done((data) => {
            VueMediaFilter.$store.commit('media/set', {
                types: data.types,
                totalTypeCount: data.total_type_count
            });
        })
        .fail((xhr) => {
            console.error('something went wrong', xhr);
        });
    }

    function recreateMediaConfirm() {
        $('#content').on('click', '.js-recreate-btn', function(e){
            e.preventDefault();
            var route = $(this).attr('href');

            confirmModal("Recreating this piece will not update information. If you need non-editable information to be updated, please start from a new piece.").then(function() {
                window.location.href = route;
            });
        });
    }

    return {

        init: function(){
            initTagIt();
            setMobileFilter();
            setQueryParams();
            loadFolders();
            loadTags();
            createVueMediaFilters();
            recreateMediaConfirm()
            loadResults(function() {
                fillOutForm();
                if(typeof options.loadResultsCallback === 'function') {
                    options.loadResultsCallback();
                }
            });

            $(window).on('popstate', function() {
                setQueryParams();
                loadTags();
                loadResults(function() {
                    fillOutForm();
                });
            });

            $('#content').on('keyup', '#js-search-field:focus', function(e) {
                if (e.which == 13) {
                    e.preventDefault();
                    resetPage();
                    setSearch();
                    applyFiltersAndLoad();
                }
            });

            $('#content').on('click', options.editTagsLink, function(){
                loadEditTagsForm(this);
            });

            $('#content').on('click', options.deleteEmailButton, function(){
                var self = this;
                confirmModal('Are you sure you want to delete this permanently?').then(function() {
                    deleteEmail(self);
                });
            });

            $('#content').on('click', options.videoModalButton, function() {
                fillInVideoModal(this);
                $videoModal.modal('show');
            });

            $('#content').on('click', '.js-archive-btn', function(e){
                e.preventDefault();
                var button = $(this);

                confirmModal('Are you sure you want to archive this media?').then(function() {
                    archiveMedia(button);
                });
            });

            $searchButton.on('click', function(){
                setSearch();
                resetPage();
                applyFiltersAndLoad();
            });

            $('#content').on('click', options.deleteSavedSocialButton, function(e){
                var self = this;
                e.preventDefault();
                e.stopPropagation();
                confirmModal('Are you sure you want to delete this permanently?').then(function() {
                    deleteSavedSocial(self);
                });
            });

            $('#content').on('change', options.sortSelect, function(){
                setSort(this);
                resetPage();
                applyFiltersAndLoad();
            });

            $('#content').on('click', options.mediaTypeItem, function(){
                setType(this);
                setFolder();
                setTags();
                resetVueTags();
                resetVueFolders();
                resetPage();
                applyFiltersAndLoad();
                recreateMediaConfirm();
            });

            $mediaStatusItem.on('click', function(){
                setStatus(this);
                resetPage();
                applyFiltersAndLoad();
                updateVueMediaFilters(queryParams);
            });

            $baseTemplateTypeItem.on('click', function(){
                baseTemplateTypeClickHandler(this);
                applyFiltersAndLoad();
                updateVueMediaFilters(queryParams);
            })

            $folderSelect.on('change', function(){
                setFolder(this);
                resetPage();
                applyFiltersAndLoad();
            });

            $('#content').on('change', options.tagSelect, function(){
                setTags(this);
                resetPage();
                applyFiltersAndLoad();
            });

            if (VueMediaFilter) {
                VueMediaFilter.$on('tagChange', function(checkedTags) {
                    queryParams.tags = checkedTags;
                    resetPage();
                    applyFiltersAndLoad();
                });
            }

            if (VueMediaFilter) {
                VueMediaFilter.$on('folderChange', function(checkedFolders) {
                    queryParams.folders = checkedFolders;
                    resetPage();
                    applyFiltersAndLoad();
                });
            }

            $submitTagsButton.on('click', function(){
                submitTags();
            });

            $listButton.on('click', function(e) {
                //checks if the click came from the user or from a jquery click trigger
                if (e.originalEvent !== undefined){
                    localStorage.setItem(options.viewTypeKey, options.listButton);
                }
            });

            $tileButton.on('click', function(e) {
                //checks if the click came from the user or from a jquery click trigger
                if (e.originalEvent !== undefined){
                    localStorage.setItem(options.viewTypeKey, options.tileButton);
                }
            });

            $('.ui-autocomplete-input').on('focus', function() {
                $('.modal .ui-autocomplete.ui-widget-content').css('background', '#fff');
            });

        }
    };
};
